<template>
  <div class="row">
    <div class="col-xls-4 col-lg-4 offset-xls-1 s-pre-order__left-section">
      <swiper
        :navigation="{
          nextEl: '.s-pre-order__next',
          prevEl: '.s-pre-order__prev',
        }"
        :pagination="{
          el: '.s-pre-order__pagination',
          type: 'bullets',
          clickable: true,
        }"
        slides-per-view="1"
        :space-between="35"
        :breakpoints="{
          320: {
            slidesPerView: 1.2,
            spaceBetween: 8,
          },
          576: {
            slidesPerView: 1.5,
            spaceBetween: 16,
          },
          768: {
            slidesPerView: 2.25,
            spaceBetween: 16,
          },
          1279: {
            slidesPerView: 'auto',
            spaceBetween: 32,
          },
        }"
        @swiper="onTextSwiper"
        @slide-change="textSliderOnChange"
        @touch-end="textSliderOnChange">
        <swiper-slide
          v-for="(record, index) in preOrderRecords"
          ref="textSlider"
          :key="index">
          <div v-if="desktop" class="s-pre-order__card">
            <div class="s-pre-order__main">
              <div class="s-pre-order__labels">
                <div class="e-label e-label--bg e-label--playing">
                  <span>{{ dictionaryData.premier }}</span>
                  {{ showOpenDate(record.due) }}
                </div>
                <div
                  v-if="record.onlyMembers"
                  class="e-label e-label--bg-goldenrod e-label--members">
                  <span>{{ dictionaryData.onlyMembers }}</span>
                </div>
              </div>

              <div class="s-pre-order__content">
                <h2 class="s-pre-order__content__title">
                  {{ record.title }}
                </h2>
                <div class="s-pre-order__content__subtitle">
                  {{ record.subTitle }}
                </div>
                <div
                  class="s-pre-order__content__description"
                  v-html="record.desc"></div>
              </div>
              <div class="b-hor-align b-hor-align--gap-16">
                <div v-if="record.pg" class="e-k">{{ record.pg }}</div>
                <div v-if="record.genre" class="movie-attr--movie">
                  {{ record.genre }}
                </div>
                <div v-if="record.dur" class="movie-attr--time">
                  <span>{{ record.dur }}</span>
                </div>
              </div>
            </div>
            <div class="s-pre-order__btn-area">
              <button
                type="button"
                class="s-pre-order__cta-btn"
                @click="redirectIntoBooking(record.movieId)">
                <span>{{ dictionaryData.bookTickets }}</span>
              </button>
              <a :href="record.url" class="s-pre-order__more-btn">
                {{ dictionaryData.more }}
              </a>
            </div>
          </div>
          <MovieCard
            v-else
            :title="record.title"
            :image="record.thumb"
            :pg="record.pg"
            :duration="record.dur"
            :dolby="record.dolby"
            :imax="record.imax"
            :imax3D="record.imax3D"
            :movie-url="record.url"
            :genres="getGenre(record.genre)"
            :dictionary="dictionary"
            :play="false"
            :movie-id="record.movieId"
            :due="showOpenDate(record.due)"
            :only-members="record.onlyMembers"></MovieCard>
        </swiper-slide>
        <div class="swiper__nav">
          <div class="swiper-button-prev s-pre-order__prev"></div>
          <div class="swiper-pagination s-pre-order__pagination"></div>
          <div class="swiper-button-next s-pre-order__next"></div>
        </div>
      </swiper>
      <div v-if="mobile || tablet" class="s-pre-order__btn-area">
        <a :href="config.stripBtnUrl" class="s-pre-order__cta-btn btn--block">
          <span>{{ dictionaryData.stripBtnTitle }}</span>
        </a>
      </div>
    </div>
    <!-- right side for poster only -->
    <div v-if="desktop" class="col-xls-6 col-lg-7">
      <div class="s-pre-order__swiper-image">
        <div class="s-pre-order__swiper-image__placeholder">
          <swiper
            ref="imageSwiper"
            class="imageSwiper"
            @swiper="onImageSwiper"
            @touch-end="moveTextSwiperByPoster">
            <swiper-slide
              v-for="(record, index) in preOrderRecords"
              :key="index">
              <div class="s-pre-order__img">
                <img
                  :src="record.thumb"
                  :alt="record.title"
                  @click="setActiveSlide(index)" />
              </div>
              <div class="s-pre-order__movie-title">
                {{ record.title }}
                <template v-if="record.subTitle">
                  <br />
                  {{ record.subTitle }}
                </template>
              </div>
            </swiper-slide>
          </swiper>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getData } from '../../lib/lib'
import constants from '../../lib/constants'
import { getFormattedDateWithSeparators } from '../../lib/date'
import bookingRedirect from '../../lib/bookingRedirect'
import { Swiper, SwiperSlide } from 'swiper/vue'
import MovieCard from '../components/MovieCard.vue'

export default {
  components: {
    MovieCard,
    Swiper,
    SwiperSlide,
  },
  data() {
    return {
      textSwiper: null,
      imageSwiper: null,
      preOrderRecords: [],
      dictionaryData: {},
      currentActiveSlide: 0,
      imageActiveSlide: 0,
      desktop: false,
      tablet: false,
      mobile: false,
    }
  },
  mounted() {
    const { dictionary, records, configuration } = getData('preOrderData')
    this.preOrderRecords = records
    this.dictionaryData = dictionary
    this.config = configuration
    this.assigntoViewports()
    window.addEventListener('resize', () => {
      this.assigntoViewports()
    })
  },
  methods: {
    redirectIntoBooking(movieId) {
      const { redirectIntoBooking } = bookingRedirect()
      redirectIntoBooking(this.config.baseUrl, movieId)
    },
    getGenre(genre) {
      if (typeof genre === 'string') {
        return [genre]
      }
      return genre
    },
    assigntoViewports() {
      this.desktop = constants.is === 'desktop'
      this.tablet = constants.is === 'tablet'
      this.mobile = constants.is === 'mobile'
    },
    showOpenDate(premierDate) {
      return getFormattedDateWithSeparators(
        premierDate,
        'en-GB',
        { year: 'numeric', month: '2-digit', day: '2-digit' },
        '.'
      )
    },
    onTextSwiper(swiper) {
      this.textSwiper = swiper
    },
    onImageSwiper(swiper) {
      this.imageSwiper = swiper
    },
    getActiveSlide(e) {
      this.currentActiveSlide = e.activeIndex
    },
    textSliderOnChange(swiper) {
      this.$nextTick(() => {
        this.imageSwiper?.slideTo(swiper.activeIndex)
      })
    },
    moveTextSwiperByPoster(swiper) {
      this.$nextTick(() => {
        this.textSwiper?.slideTo(swiper.activeIndex)
      })
    },
    setActiveSlide(indx) {
      if (this.currentActiveSlide !== indx) {
        this.textSwiper?.slideTo(indx)
      }
    },
  },
}
</script>
